export default {
  init() {

    // var scrollPosition, lastScrollPosition;

    // if($(window).scrollTop() == 0){
    //   $('.to-top').addClass('hidden');
    // }

    // $('.to-top').on('click touch', function(e){
    //   $('html, body').animate(
    //     {
    //       scrollTop: 0,
    //     },
    //     400,
    //     'linear');
    //   e.preventDefault();
    //   return false;
    // });

    // // Transition effect for navbar
    // $(window).scroll(function () {
    //   // checks if window is scrolled more than 500px, adds/removes solid class
    //   scrollPosition = $(this).scrollTop();
    //   if (scrollPosition > 0) {
    //     $('.banner').addClass('solid');
    //     $('.to-top').removeClass('hidden');
    //   } else {
    //     $('.banner').removeClass('solid');
    //     $('.to-top').addClass('hidden');
    //   }

    //   if (lastScrollPosition < scrollPosition
    //       && scrollPosition > 0) {
    //     $('.banner').addClass('hidden');
    //   } else {
    //     $('.banner').removeClass('hidden');
    //   }

    //   lastScrollPosition = scrollPosition;

      //pause any carousels
      $('.carousel').each( function() {
          var docViewTop = $(window).scrollTop();
          var docViewBottom = docViewTop + $(window).height();

          var elemTop = $(this).offset().top;
          var elemBottom = elemTop + $(this).height();

          if( ! ((elemBottom <= docViewBottom) && (elemTop >= docViewTop)) ) {
            $(this).carousel('dispose');
          }else {
            $(this).carousel();
          }
      });

    // Update mobile menu with logo and order online
    let orderOnline = $('.mega-online');
    let orderOnlineID = orderOnline.prop('id');
    $('.mega-toggle-blocks-left').append(orderOnline.clone().prop('id','mobile-'+orderOnlineID));

    let homeLogo = $('.mega-home');
    let homeLogoID = homeLogo.prop('id');
    $('.mega-toggle-blocks-center').append(homeLogo.clone().prop('id', 'mobile-' + homeLogoID));


    //Begin logic for placeholder newsletter in footer
    $('.footer-enews input').focus(function(){
      $(this).attr('placeholder', 'enter your email...')
    }).blur(function(){
      $(this).attr('placeholder', 'subscribe to our newsletter')
    });

    //get form from content-newsletter.blade
    var $form = $('#mc-embedded-subscribe-form')
    if ($form.length > 0) {
      $form.bind('submit', function (event) {
        if (event) event.preventDefault()
        register($form)
      })
    }

    function register($form) {
      $('#mc-embedded-subscribe').val('Sending...');
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache: false,
        dataType: 'jsonp',
        contentType: 'application/json; charset=utf-8',
        error: function (err) {
          //do something if cannot connect
          alert('Could not connect to the registration server. Please try again later.');
          console.log(err);
        },
        success: function (data) {
          $('#mc-embedded-subscribe').val('subscribe');
          if (data.result === 'success') {
            // Yeahhhh Success
            console.log(data);
            $('#mce-EMAIL').css('borderColor', '#ffffff');
            $('#subscribe-result').css({'color' : '#fff', 'padding' : '20px', 'opacity' : '1'});
            $('#subscribe-result').html('<p>Thank you for subscribing! We have sent you a confirmation email.</p>');
            $('#mce-EMAIL').val('');
          } else {
            // Something went wrong, do something to notify the user.
            console.log(data);
            $('#mce-EMAIL').css('borderColor', '#cb5220');
            $('#subscribe-result').css({'color' : '#cb5220', 'padding' : '20px', 'opacity' : '1'});
            $('#subscribe-result').html('<p>' + data.msg + '</p>');
          }
        },
      })
    }
  },
  finalize() {
    function viewportHeight() {
      //Calculate the actual height
      let vh = (window.innerHeight - $('#at-share-dock').height()) * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    }

    $(window).on('resize', viewportHeight);
    $('.mega-menu-toggle').on('click touch', viewportHeight);
    viewportHeight();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js